import type { ClassHomeItem, ClassItem, User } from "./types";

export interface HomeClassSummary extends ClassItem {
  chat_count: number;
}

export function deriveWorkspaceSurface(
  selectedClassId: string | null,
): "home" | "classroom" {
  return selectedClassId ? "classroom" : "home";
}

export function canManageClassroomControls(role: User["role"]): boolean {
  return role === "ADMIN" || role === "TEACHER";
}

export function mergeHomeClasses(
  classes: ClassItem[],
  homeClasses: ClassHomeItem[],
): HomeClassSummary[] {
  const homeById = new Map(homeClasses.map((item) => [item.id, item]));
  const classIds = new Set<string>();

  const merged = classes.map((classItem) => {
    classIds.add(classItem.id);
    const homeItem = homeById.get(classItem.id);

    if (!homeItem) {
      return {
        ...classItem,
        chat_count: 0,
      };
    }

    return {
      ...classItem,
      ...homeItem,
    };
  });

  for (const homeItem of homeClasses) {
    if (classIds.has(homeItem.id)) continue;
    merged.push(homeItem);
  }

  return merged;
}
